module.exports = __webpack_public_path__ + "static/img/14010792.61001171.png";